<div class="container">
  <mat-card>
    <app-upload-list></app-upload-list>
    <mat-card-actions>
      <button mat-button (click)="logout()">Logout</button>
    </mat-card-actions>
  </mat-card>
</div>
